import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import type User from '../domain/auth';
import { type AuthState } from '../domain/auth';

const initialState: AuthState = {
    isAuthenticated: false,
    token: null,
    user: null
};

const authSlice = createSlice({
    initialState,
    name: 'auth',
    reducers: {
        clearToken: (state) => {
            state.token = null;
        },
        clearUser: (state) => {
            state.user = null;
            state.isAuthenticated = false;
        },
        setToken: (state, action: PayloadAction<string | null>) => {
            state.token = action.payload;
        },
        setUser: (state, action: PayloadAction<User | null>) => {
            state.user = action.payload;
            state.isAuthenticated = true;
        },
    },
});

export const { setUser, clearUser, setToken, clearToken } = authSlice.actions;
export default authSlice.reducer;